import { computed, ref } from 'vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import { useModuleConfig } from '@rebuild/hooks/data/useModuleConfig';
import dayjs from 'dayjs';
import { resolvePageId } from '@rebuild/utils/context';

export const useSurfReport = () => {
	const { report } = useModuleData();
	const { config, loadModuleConfig } = useModuleConfig();
	const { viewModule } = useModuleNavigation();

	const initConfig = async () => {
		await loadModuleConfig('report');
	};
	const reportTypeRange = computed(() => {
		const tabs = config.value?.tab || [];

		const parseValue = item => {
			// 特殊：全部
			if (item.id === 'report_all') return '';
			return item.value;
		};

		return tabs
			.filter(tab => tab.isPublish)
			.sort((a, b) => a.sort - b.sort)
			.map(tab => {
				const mainId = parseValue(tab);

				const subIds = (tab.subTabList || []).map(sub => parseValue(sub.id)).filter(Boolean); // 自动去掉空字符串

				const tabId = [mainId, ...subIds].filter(Boolean).join(',');

				return {
					...tab,
					tabId,
					label: tab.name
				};
			});
	});

	const getFullTypeRange = () => {
		const types = reportTypeRange.value.map(item => item.tabId);

		// 全量查询
		// 区分「全部」是否包含子类型的情况
		const allValue = '';
		if (types.includes(allValue)) return allValue;

		// 数组输出
		return reportTypeRange.value.map(item => item.tabId);
	};

	const activeType = ref('');
	// 切换分类
	const handleTypeChange = tabId => {
		activeType.value = tabId;
	};

	// 数据
	const reportData = computed(() => {
		return report.data?.rows || [];
	});

	// 加载数据
	const loadReportData = async (params = {}) => {
		const options = {
			pageStart: params.pageStart,
			pageNum: params.pageNum,
			pageId: resolvePageId()
		};
		if (params.rating) options.rating = params.rating;
		await report.refresh(options);
	};

	const formatForOverview = item => {
		return {
			date: item.publishDate || '',
			value: item.title || ''
		};
	};
	const formatForFull = item => {
		return {
			value: item.title || '',
			valueList: [item.rating, item.publishDate ? dayjs(item.publishDate).format('YYYY.MM.DD') : ''].filter(
				Boolean
			)
		};
	};

	// 预览详情
	const handlePreview = item => {
		viewModule('report', item);
	};

	// 是否为空
	const isEmpty = computed(() => {
		return report.empty || !reportData.value.length;
	});

	return {
		initConfig,
		reportTypeRange,
		getFullTypeRange,
		activeType,
		handleTypeChange,
		report,
		reportData,
		loadReportData,
		formatForOverview,
		formatForFull,
		handlePreview,
		isEmpty
	};
};
